"use client";
import { Timeline } from "@/components/ui/timeline";
import { experiences } from "@/utils/data/experience";
import SectionHeading from "../../section-heading";

function Experience() {
  const data = experiences.map((item) => ({
    title: item.title,
    content: (
      <div className="rounded-2xl border border-white/10 bg-neutral-900/50 p-6 backdrop-blur-sm">
        <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
          <div>
            <h4 className="text-xl md:text-2xl font-semibold text-white">{item.role}</h4>
            <p className="text-violet-300 mt-1">{item.company}</p>
          </div>
          <div className="flex gap-2">
            <span className="px-3 py-1 text-xs rounded-full border border-emerald-500/30 bg-emerald-500/10 text-emerald-300">
              {item.type}
            </span>
            <span className="px-3 py-1 text-xs rounded-full border border-cyan-500/30 bg-cyan-500/10 text-cyan-300">
              {item.location}
            </span>
          </div>
        </div>

        {item.site ? (
          <a
            href={item.site}
            target="_blank"
            rel="noreferrer"
            className="inline-block text-sm text-cyan-400 hover:text-cyan-300 mb-4"
          >
            {item.site.replace("https://", "")} →
          </a>
        ) : null}

        <ul className="space-y-2.5 text-neutral-300 text-sm leading-relaxed">
          {item.points.map((point) => (
            <li key={point} className="flex gap-3">
              <span className="mt-2 h-1.5 w-1.5 rounded-full bg-gradient-to-r from-cyan-400 to-violet-500 shrink-0" />
              <span>{point}</span>
            </li>
          ))}
        </ul>

        <div className="flex flex-wrap gap-2 mt-5">
          {item.skills.map((skill) => (
            <span
              key={skill}
              className="px-3 py-1 text-xs rounded-lg bg-white/5 border border-white/10 text-neutral-300"
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    ),
  }));

  return (
    <section id="experience" className="relative py-24">
      <SectionHeading
        eyebrow="[Experience]"
        title="Career"
        highlight="timeline"
        description="Production SaaS, enterprise GRC, mentoring, and real-world product delivery."
      />
      <Timeline data={data} />
    </section>
  );
}

export default Experience;
